import { Typography } from '@material-ui/core';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import { useSnackbar } from 'notistack';
import Grid from '@material-ui/core/Grid';
import { useFileDrop } from './dragDrop';
import useStyles from './styles';
import { getLastDate } from '../../../services/documento/DocumentoService';
import BotaoDownload from '../../documento/botaoDownload';

const UploadFile = (props) => {
  const classes = useStyles();
  const {
    onUpload, titulo, termoPosse, handleDownload, onDelete, allowedExtensions
  } = props;
  const [carregarTermoPosse, setCarregarTermoPosse] = useState(false);
  const [carregado, setCarregado] = useState(false);
  const [file, setFile] = useState({});
  const { enqueueSnackbar } = useSnackbar();

  const extensoesPermitidas = allowedExtensions ?? ['doc', 'docx', 'ppt', 'pptx', 'pdf', 'xls', 'xlsx',
    'png', 'jpg', 'jpeg', 'mp4', 'avi', 'wav', 'mpeg', 'mp3'];

  useEffect(() => {
    if (termoPosse) {
      setCarregarTermoPosse(Boolean(termoPosse.name))
    }
  }, [])

  const validarExtensao = (extensao) => extensoesPermitidas.includes(extensao.toLowerCase());

  const onChangeHandler = (event) => {
    if (event.target.files) {
      const file = event.target.files[0];
      const extensao = file.name.split('.').pop();
      const extensaoValida = validarExtensao(extensao);

      if (extensaoValida) {
        setFile(file);
        setCarregado(true)
        onUpload(file);
      } else {
        enqueueSnackbar('Arquivo com formato inválido', { variant: 'error' })
      }
    }
  }


  const fileDrop = (file) => {
    setFile(file);
    setCarregado(true)
    onUpload(file);
  }

  const { DropBox, HiddenInput, drag } = useFileDrop(fileDrop);

  const handleDelete = () => {
    setFile({});
    setCarregado(false);
    setCarregarTermoPosse(false);
    if(onDelete)
      onDelete();
  }

  const getSize = (tamanho) => {
    if (tamanho >= (1024 * 1024 * 1024)) {
      return `${parseInt(tamanho / (1024 * 1024 * 1024))}gb`;
    }
    if (tamanho >= (1024 * 1024)) {
      return `${parseInt(tamanho / (1024 * 1024))}mb`;
    }
    if (tamanho >= 1024) {
      return `${parseInt(tamanho / 1024)}kb`;
    }
    return `${tamanho}bytes`;
  }

  const getType = (tipo) => {
    switch (tipo) {
      case 'application/pdf':
        return 'PDF';
      default:
        break;
    }
  }

  const getLastUploadDate = () => {
    const dataHoje = new Date().getTime();
    const dataUpload = dataHoje;
    const dias = dataHoje - dataUpload;

    if (dias >= 1000 * 3600 * 24) {
      return ` há ${parseInt((dataHoje - dataUpload) / (1000 * 3600 * 24))} dias`
    }
    return ' hoje';
  };

  const uploadFile = (
    <div>
      <Typography className={classes.titulo}>{titulo}</Typography>
      <HiddenInput />
      <DropBox className={drag ? classes.campoOnDragAtivo : classes.campoOnDrag}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <DescriptionOutlinedIcon className={classes.dropIcon} />
          <label className={classes.mainButon} htmlFor="input-termo-posse" role="button">
            Adicionar arquivo
          </label>
          <input
            style={{ display: 'none' }}
            id="input-termo-posse"
            type="file"
            name="file"
            onChange={onChangeHandler}
          />
        </div>
        <Typography paragraph>ou arraste os arquivos aqui para adiciona-los</Typography>
      </DropBox>
    </div>

  )

  const uploadedFile = (
    <div>
      <Typography className={classes.titulo}>{titulo}</Typography>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Grid container spacing={3}>
          <Grid item xs={7}>
            <p className={classes.fileLabeles}>Nome</p>
          </Grid>
          <Grid item xs={5}>
            <p className={classes.fileLabeles}>Tamanho</p>
          </Grid>
        </Grid>
      </div>
      <div className={classes.campoFile}>
        <div style={{ display: 'flex', alignItems: 'center', maxWidth: '50%' }}>
          <DescriptionOutlinedIcon style={{ fontSize: 20, marginRight: 10 }} />
          <div>
            <p className={classes.nomeFile}>{file.name}</p>
            <span
              className={classes.nomeFileSpan}
            >
              Adicionado {getLastUploadDate()} - {getType(file.type)}
            </span>
          </div>
        </div>

        <p style={{ paddingTop: 15 }} className={classes.tamanhoFile}>{getSize(file.size)}</p>

        <div>
          <DeleteOutlinedIcon style={{ fontSize: 20 }} onClick={handleDelete} />
        </div>
      </div>
    </div>
  )


  const loadTermoPosse = (
    termoPosse && (
      <div>
        <Typography className={classes.titulo}>{titulo}</Typography>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Grid container spacing={3}>
            <Grid item xs={7}>
              <p className={classes.fileLabeles}>Nome</p>
            </Grid>
            <Grid item xs={5}>
              <p className={classes.fileLabeles}>Tamanho</p>
            </Grid>
          </Grid>
        </div>
        <div className={classes.campoFile}>
          <div style={{ display: 'flex', alignItems: 'center', maxWidth: '50%' }}>
            <DescriptionOutlinedIcon style={{ fontSize: 20, marginRight: 10 }} />
            <div>
              <p className={classes.nomeFile}>{termoPosse.name}</p>
              <span
                className={classes.nomeFileSpan}
              >
                Adicionado
                {' '}
                {getLastDate(termoPosse.uploadDate)}
                {' '}
                -
                {termoPosse.type}
              </span>
            </div>
          </div>

          <p style={{ paddingTop: 15 }} className={classes.tamanhoFile}>{getSize(termoPosse.size)}</p>

          <div>
            {handleDownload && <BotaoDownload onClickHandle={handleDownload} />}
            {onUpload && <DeleteOutlinedIcon style={{ fontSize: 20 }} onClick={handleDelete} />}
          </div>
        </div>
      </div>
    )
  )

  if (carregarTermoPosse) {
    return loadTermoPosse
  }
  return (
    carregado ? uploadedFile : uploadFile
  )
}

export default UploadFile;

UploadFile.propTypes = {
  onUpload: PropTypes.func.isRequired,
  titulo: PropTypes.string,
};
